<template>
  <div class="page">
      <div class="box">
          <div class="top">中山市云彩信息科技有限公司</div>
          <div class="title"><img src="@/assets/images/more.png" /> 售后电话</div>
          <div class="content">0760-22639933</div>
          <div class="title"><img src="@/assets/images/more.png" /> 技术微信</div>
          <div class="content">13790730112</div>
      </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            isRider: false
        }
    },
    created() {
        this.isRider = (window.JS && JS.isRider) ? JS.isRider() : false;
    },
    

}
</script>

<style lang="scss" scoped>
.page{
    height: 100vh;
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f7f7f7;
    min-height: 100vw;
    .box{
        width: 70vw;
        height:fit-content;
        background: white;
        border-radius: 10px;
        overflow: hidden;
        text-align: center;
        box-shadow: 1px 1px 38px 0px rgba(189, 189, 189, 0.41);
        padding-bottom: 3vw;
        .top{
            background: #2e8dff;
            line-height: 12vw;
            color: white;
            font-size: 5.6vw;
            font-family: Microsoft YaHei;
            font-weight: 400;
        }
        .title{
            line-height: 13vw;
            font-size: 6.2vw;
            color: #666666;
            display: flex;
            align-items: center;
            justify-content: center;
            img{
                width: 2.8vw;
                margin-right: 2vw;
            }
        }
        .content{
            line-height: 9vw;
            font-size: 6vw;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #2E8DFF
        }
    }
}
</style>